// Smart Sash Admin Panel - RFID Activation Hook
// Thin wrapper around useActivationFlow with RFID-specific config

import {
  CardAssignmentCancelationEvent,
  CardAssignmentConfirmationEvent,
} from '@/generated/Common/CardAssignmentEvents';
import { rfidAuthService } from '@/services/api';
import { ActivationFlowConfig, ActivationFlowState, useActivationFlow } from './useActivationFlow';

export type { ActivationStatus } from './useActivationFlow';
export type { ActivationFlowState as RFIDActivationState };

const RFID_CONFIG: ActivationFlowConfig = {
  confirmationEvents: ['CardAssignmentConfirmationEvent'],
  cancellationEvent: 'CardAssignmentCancelationEvent',
  decoders: {
    decodeConfirmation: (data) => CardAssignmentConfirmationEvent.decode(data).success,
    decodeCancellation: (data) => {
      CardAssignmentCancelationEvent.decode(data);
    },
  },
  requestFn: (params) => rfidAuthService.requestAssignment(params),
  revokeFn: (params) => rfidAuthService.revokeAssignment(params),
  cancelledMessage: 'Registration was cancelled by the user',
};

/**
 * Manages gRPC subscription and RFID assignment request for the activation page.
 * Decodes VerificationCodeSentEvent to display the code and countdown.
 */
export const useRFIDActivation = (
  sessionId: string | null,
  institutionId: string | null,
  labId: string | null
): ActivationFlowState => {
  return useActivationFlow(sessionId, institutionId, labId, RFID_CONFIG);
};
